import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler } from "@angular/common/http";
import { TokenService } from "./token.service";
import { AuthService } from "./auth.service";
import { tap, switchMap, retry, take, debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { apiUrl } from "../config/api-url";
import { UserDataService } from "./shared/user-data.service";

@Injectable({
	providedIn: "root",
})
export class RequestInterceptorService implements HttpInterceptor {
	private lastRefreshTime: number = 0; // timestamp of when token was refreshed

	/**
	 * If more than a minute had passed since the last time token was refreshed, first
	 * refresh the token and then proceed with the client request.
	 */
	private refreshInterval: number = 120 * 1000;

	private refreshing: boolean = false;

	private refreshed$: Subject<void> = new Subject<void>();

	private refresh$: Subject<void> = new Subject<void>();

	constructor(private authService: AuthService, private token: TokenService, private router: Router, private userDataService: UserDataService) {
		this.refresh$.pipe(debounceTime(5000)).subscribe(() => {
			this.refreshing = true;
			this.authService.refresh().subscribe(
				() => {
					console.log("Token refreshed");
					this.refreshing = false;
					this.refreshed$.next();
				},
				(error) => {
					console.log("Error while refreshing token");
					this.refreshing = false;
					this.refreshed$.next();
				}
			);
		});
	}

	//   public intercept(req: HttpRequest<any>, next: HttpHandler) {
	//     if ( !this.token.isValid() && this.requiresAuthentication(req)) {
	//       this.router.navigateByUrl('/login');
	//       return;
	//     }
	//     // Token lifetime has been set to infinity so there is no need to refresh it
	//     // if ( this.requiresAuthentication(req) && !this.refreshing ) {
	//     //   this.refresh$.next();
	//     //   // this.refreshing = true;
	//     //   // this.authService.refresh().subscribe(() => {
	//     //   //   this.lastRefreshTime = Date.now();
	//     //   //   this.refreshing = false;
	//     //   //   this.refresh$.next();
	//     //   // });
	//     // }
	//     // Put other requests in que untill token refresh request is done
	//     if (this.refreshing && this.requiresAuthentication(req)) {
	//       return this.refreshed$.pipe(
	//         take(1),
	//         switchMap(() => {
	//           // if (req.method == 'GET') {
	//           //   return next.handle(this.tokenize(req));
	//           // }
	//           return next.handle(this.tokenize(req));
	//         })
	//       );
	//     }
	//     // if (req.method == 'GET') {
	//     //   return next.handle(this.tokenize(req)).pipe(retry(3));
	//     // }
	//     return next.handle(this.tokenize(req));
	//   }

	public intercept(req: HttpRequest<any>, next: HttpHandler) {
		if (!this.token.isValid() && this.requiresAuthentication(req)) {
			this.userDataService.userData$.pipe(take(1)).subscribe((data) => {
				if (data.user.role === "vendor_admin") {
					console.log("I redirect to auth", data);
					this.router.navigateByUrl("/auth/" + data.company_short_name);
				} else {
					this.router.navigateByUrl("/login");
				}
				return;
			});
		}
		if (this.refreshing && this.requiresAuthentication(req)) {
			return this.refreshed$.pipe(
				take(1),
				switchMap(() => {
					return next.handle(this.tokenize(req));
				})
			);
		}
		return next.handle(this.tokenize(req));
	}

	private tokenAged(): boolean {
		return this.lastRefreshTime + this.refreshInterval < Date.now();
	}

	private tokenize(req: HttpRequest<any>) {
		if (req.url.startsWith(apiUrl)) {
			return req.clone({
				setHeaders: { Authorization: `Bearer ${this.token.get()}` },
			});
		}
		return req;
	}

	private requiresAuthentication(req: HttpRequest<any>): boolean {
		return !req.url.includes("auth/refresh") && !req.url.includes("auth/login") && !req.url.includes("auth/register") && !req.url.includes("auth/logout") && !req.url.includes("auth/account-verification") && !req.url.includes("auth/send-password-reset-link") && !req.url.includes("auth/password-reset") && !req.url.includes("auth/me") && !req.url.includes("company-names/showrooms") && !req.url.includes("company-names/vendors") && !req.url.includes("showroom/sent-contracts") && !req.url.includes("showroom/project-pictures") && !req.url.includes("companies/search") && !req.url.includes("api/manufacturers/") && !req.url.includes("api/page-content");
	}
}
